// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContent":"_35dL6QRj","disclaimerIcon":"_3oAngkxQ","subtitle":"_2l1PuinJ","itemCount":"_1nwA-WvQ","warningOption":"t0OIyvUv","warningOptionLabel":"_24sxtVzv"};